"use client";
import React from "react";
import Link from "next/link";
import { useInventoryNav } from "./InventoryNavContext";

/**
 * Client breadcrumb link that routes navigation through the shared inventory
 * transition, so going "up" the category tree shows the same grid loading
 * state as filtering. Modifier/middle clicks fall through to the default
 * <Link> behaviour (open in new tab, etc.).
 */
export default function BreadcrumbLink({
  href,
  className,
  children,
}: {
  href: string;
  className?: string;
  children: React.ReactNode;
}) {
  const { navigate, isNavigating } = useInventoryNav();

  return (
    <Link
      href={href}
      className={`${className ?? ""} ${isNavigating ? "pointer-events-none" : ""}`}
      aria-disabled={isNavigating || undefined}
      onClick={(e) => {
        if (isNavigating) {
          e.preventDefault();
          return;
        }
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
          return;
        }
        e.preventDefault();
        navigate(href);
      }}
    >
      {children}
    </Link>
  );
}
